import { Navigate } from "react-router-dom";
import React from "react";
import { useUser } from "../../context/UserContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useUser();
  const token = localStorage.getItem("token");

  if (!token) return <Navigate to="/admin/login" />;
  if (loading) return null;
  if (user && !user.is_activated) {
    return <Navigate to="/admin/mainpage" />;
  }
  if (adminOnly && user && !user.is_admin) {
    return <Navigate to="/admin/mainpage" />;
  }
  return children;
}